<template>
    <div v-can-read="['creative-management', 'creative']" class="creative-management-mf-vue2" data-app>
        <VApp id="creative-management" class="creative-management">
            <SrAppContainer id="creative-management-content" class="mf-container gray-lightest">
                <template #sidebar>
                    <SideNavigation />
                </template>
                <template #content>
                    <RouterView />
                </template>
            </SrAppContainer>
        </VApp>
    </div>
</template>
<script>
import { SrAppContainer } from '@ads/design-system';
import SideNavigation from '@/components/navigation/SideNavigation';
import '@/app.scss';

export default {
    name: 'App',
    components: {
        SrAppContainer,
        SideNavigation,
    },
    created() {
        this.$store.dispatch('iamStore/getBusinessEntities');
    },
};
</script>
